const state = {
  notifications: [],
  alertsNotifications: [],
  lastNotificationId: null,
}

export default state
